import * as React from "react";

import { cn } from "@/lib/utils";

// 自作ラベル（radix 非依存の素の <label>）。
function Label({ className, ...props }: React.ComponentProps<"label">) {
  return (
    <label
      data-slot="label"
      className={cn(
        "flex select-none items-center gap-2 text-sm font-medium leading-none",
        className
      )}
      {...props}
    />
  );
}

export { Label };
